/** The project list, which doubles as the API-keys entry point. */
const en = {
  title: 'API Keys',
  subtitle: 'One project per site or app. Open a project to manage its API keys.',
  newProject: 'New project',
  empty: 'No projects yet. Create one to get started.',
  key: 'Key',
  retention: 'Retention',
  days: 'd',
  sampling: 'Sampling',
  perVisitor: 'per visitor',
  perSession: 'per session',
  restricted: 'recording restricted',
  dialogTitle: 'New project',
  projectName: 'Project name',
};

const tr: typeof en = {
  title: 'API Anahtarları',
  subtitle: 'Her site ya da uygulama için bir proje. Anahtarlarını yönetmek için projeyi açın.',
  newProject: 'Yeni proje',
  empty: 'Henüz proje yok. Başlamak için bir tane oluşturun.',
  key: 'Anahtar',
  retention: 'Saklama',
  days: 'g',
  sampling: 'Örnekleme',
  perVisitor: 'ziyaretçi başına',
  perSession: 'oturum başına',
  restricted: 'kayıt kısıtlı',
  dialogTitle: 'Yeni proje',
  projectName: 'Proje adı',
};

export const projects = { en, tr };
